export default __webpack_public_path__ + "static/media/logo-w.85d31687.png";